import React from "react";
import { LuCalendarHeart } from "react-icons/lu";
import useUnsavedCounts from "../../Hooks/useUnsavedCounts";
import { Button, IconButton } from "../ui/Button/index.js";
import { useTranslation, Trans } from "react-i18next";

/**
 * EventNotification component that displays a notification for unsaved events and spaces.
 * 
 * @param {Object} props - Component props.
 * @param {boolean} props.showMessage - State to control the visibility of the notification message.
 * @param {Function} props.setShowMessage - Function to toggle the message visibility.
 * @param {Object} props.history - History object for navigation.
 */
export default function EventNotification({ showMessage, setShowMessage, history }) {
    const { t } = useTranslation();
    const { eventCount, spaceCount, totalProducts } = useUnsavedCounts();
    const totalUnsavedEvents = eventCount + spaceCount;

    if (totalUnsavedEvents === 0 && totalProducts === 0) {
        return null;
    }

    return (
        <div className="relative">
            <IconButton
                variant="outline"
                size="sm"
                className="border-red-400"
                onClick={() => setShowMessage(!showMessage)}
                icon={
                    <div className="flex items-center gap-2">
                        <LuCalendarHeart className="h-5 w-5" />
                        <span className="text-red-400">
                            {totalUnsavedEvents}
                        </span>
                    </div>
                }
            />
            {showMessage && (
                <div className="absolute right-0 top-12 z-10 w-[300px] rounded-md bg-white p-4 shadow-lg">
                    <h4 className="text-lg font-medium">{t("notifications.importantMessage")}</h4>
                    <p className="text-sm text-gray-500">
                        <Trans
                            i18nKey="events.unsavedNotification"
                            values={{ eventCount: totalUnsavedEvents, productCount: totalProducts }}
                            components={[
                                <span key="0" />,
                                <span key="1" className="text-red-400" />,
                                <span key="2" />,
                                <span key="3" className="text-red-400" />,
                                <span key="4" />,
                                <span
                                    key="5"
                                    onClick={() => history.push("/login")}
                                    className="text-red-500 cursor-pointer"
                                />
                            ]}
                        />
                    </p>
                    <Button
                        variant="ghost"
                        className="text-red-500 hover:bg-gray-100"
                        onClick={() => setShowMessage(false)}
                    >
                        {t("common.close")}
                    </Button>
                </div>
            )}
        </div>
    );
}
